import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { IWorkbookBase } from '~src/ts/models/IWorkbookInfo';
import { Messages } from '~src/codegen/Localize';
import { ToasterService, ToastType } from '~src/ts/services/ToasterService';
import { WorkbookErrors } from '~src/content/services/WorkbookErrors';
import { Workbooks } from '~src/content/resources/Workbooks';

export namespace ChangeWorkbookDescriptionAction {
  export function execute(workbook: IWorkbookBase, newDescription: string): Promise<IResult> {

    return Workbooks.setDescription(workbook.id, newDescription).then((result: IResult) => {
      if (result.errors && result.errors.length) {
        ToasterService.instance.pop({
          type: ToastType.Error,
          text: WorkbookErrors.errorMessageFor({ item: workbook, error: result.errors[0] })
        });
      } else {
        ToasterService.instance.pop({ type: ToastType.Success, text: Messages.editDescriptionSuccessful() });
      }
      return result;
    });
  }
}

export type ChangeWorkbookDescriptionAction = typeof ChangeWorkbookDescriptionAction;
